import { TagModels } from '../enums';

export interface ITagOutputDto {
    id: string;
    name: string;
    color?: string;
    model: TagModels;
}
